import dn, { useRef as cn, useEffect as fn } from "react";
var mn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var or = { exports: {} }, Gr = function(e, t) {
  return function() {
    for (var i = new Array(arguments.length), o = 0; o < i.length; o++)
      i[o] = arguments[o];
    return e.apply(t, i);
  };
}, bn = Gr, Q = Object.prototype.toString;
function Xr(r) {
  return Q.call(r) === "[object Array]";
}
function Qe(r) {
  return typeof r > "u";
}
function vn(r) {
  return r !== null && !Qe(r) && r.constructor !== null && !Qe(r.constructor) && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function wn(r) {
  return Q.call(r) === "[object ArrayBuffer]";
}
function hn(r) {
  return typeof FormData < "u" && r instanceof FormData;
}
function gn(r) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && r.buffer instanceof ArrayBuffer, e;
}
function yn(r) {
  return typeof r == "string";
}
function En(r) {
  return typeof r == "number";
}
function Kr(r) {
  return r !== null && typeof r == "object";
}
function Tn(r) {
  return Q.call(r) === "[object Date]";
}
function On(r) {
  return Q.call(r) === "[object File]";
}
function Sn(r) {
  return Q.call(r) === "[object Blob]";
}
function Zr(r) {
  return Q.call(r) === "[object Function]";
}
function xn(r) {
  return Kr(r) && Zr(r.pipe);
}
function Cn(r) {
  return typeof URLSearchParams < "u" && r instanceof URLSearchParams;
}
function An(r) {
  return r.replace(/^\s*/, "").replace(/\s*$/, "");
}
function Pn() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function xe(r, e) {
  if (!(r === null || typeof r > "u"))
    if (typeof r != "object" && (r = [r]), Xr(r))
      for (var t = 0, n = r.length; t < n; t++)
        e.call(null, r[t], t, r);
    else
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && e.call(null, r[i], i, r);
}
function Jr() {
  var r = {};
  function e(i, o) {
    typeof r[o] == "object" && typeof i == "object" ? r[o] = Jr(r[o], i) : r[o] = i;
  }
  for (var t = 0, n = arguments.length; t < n; t++)
    xe(arguments[t], e);
  return r;
}
function er() {
  var r = {};
  function e(i, o) {
    typeof r[o] == "object" && typeof i == "object" ? r[o] = er(r[o], i) : typeof i == "object" ? r[o] = er({}, i) : r[o] = i;
  }
  for (var t = 0, n = arguments.length; t < n; t++)
    xe(arguments[t], e);
  return r;
}
function kn(r, e, t) {
  return xe(e, function(i, o) {
    t && typeof i == "function" ? r[o] = bn(i, t) : r[o] = i;
  }), r;
}
var B = {
  isArray: Xr,
  isArrayBuffer: wn,
  isBuffer: vn,
  isFormData: hn,
  isArrayBufferView: gn,
  isString: yn,
  isNumber: En,
  isObject: Kr,
  isUndefined: Qe,
  isDate: Tn,
  isFile: On,
  isBlob: Sn,
  isFunction: Zr,
  isStream: xn,
  isURLSearchParams: Cn,
  isStandardBrowserEnv: Pn,
  forEach: xe,
  merge: Jr,
  deepMerge: er,
  extend: kn,
  trim: An
}, Z = B;
function Or(r) {
  return encodeURIComponent(r).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Qr = function(e, t, n) {
  if (!t)
    return e;
  var i;
  if (n)
    i = n(t);
  else if (Z.isURLSearchParams(t))
    i = t.toString();
  else {
    var o = [];
    Z.forEach(t, function(f, S) {
      f === null || typeof f > "u" || (Z.isArray(f) ? S = S + "[]" : f = [f], Z.forEach(f, function(P) {
        Z.isDate(P) ? P = P.toISOString() : Z.isObject(P) && (P = JSON.stringify(P)), o.push(Or(S) + "=" + Or(P));
      }));
    }), i = o.join("&");
  }
  if (i) {
    var m = e.indexOf("#");
    m !== -1 && (e = e.slice(0, m)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}, Mn = B;
function Ce() {
  this.handlers = [];
}
Ce.prototype.use = function(e, t) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t
  }), this.handlers.length - 1;
};
Ce.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
Ce.prototype.forEach = function(e) {
  Mn.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var Rn = Ce, In = B, Un = function(e, t, n) {
  return In.forEach(n, function(o) {
    e = o(e, t);
  }), e;
}, Be, Sr;
function et() {
  return Sr || (Sr = 1, Be = function(e) {
    return !!(e && e.__CANCEL__);
  }), Be;
}
var Nn = B, Vn = function(e, t) {
  Nn.forEach(e, function(i, o) {
    o !== t && o.toUpperCase() === t.toUpperCase() && (e[t] = i, delete e[o]);
  });
}, Fe, xr;
function Bn() {
  return xr || (xr = 1, Fe = function(e, t, n, i, o) {
    return e.config = t, n && (e.code = n), e.request = i, e.response = o, e.isAxiosError = !0, e.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, e;
  }), Fe;
}
var Le, Cr;
function rt() {
  if (Cr)
    return Le;
  Cr = 1;
  var r = Bn();
  return Le = function(t, n, i, o, m) {
    var v = new Error(t);
    return r(v, n, i, o, m);
  }, Le;
}
var _e, Ar;
function Fn() {
  if (Ar)
    return _e;
  Ar = 1;
  var r = rt();
  return _e = function(t, n, i) {
    var o = i.config.validateStatus;
    !o || o(i.status) ? t(i) : n(r(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, _e;
}
var We, Pr;
function Ln() {
  return Pr || (Pr = 1, We = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), We;
}
var qe, kr;
function _n() {
  return kr || (kr = 1, qe = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), qe;
}
var De, Mr;
function Wn() {
  if (Mr)
    return De;
  Mr = 1;
  var r = Ln(), e = _n();
  return De = function(n, i) {
    return n && !r(i) ? e(n, i) : i;
  }, De;
}
var je, Rr;
function qn() {
  if (Rr)
    return je;
  Rr = 1;
  var r = B, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return je = function(n) {
    var i = {}, o, m, v;
    return n && r.forEach(n.split(`
`), function(S) {
      if (v = S.indexOf(":"), o = r.trim(S.substr(0, v)).toLowerCase(), m = r.trim(S.substr(v + 1)), o) {
        if (i[o] && e.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? i[o] = (i[o] ? i[o] : []).concat([m]) : i[o] = i[o] ? i[o] + ", " + m : m;
      }
    }), i;
  }, je;
}
var ze, Ir;
function Dn() {
  if (Ir)
    return ze;
  Ir = 1;
  var r = B;
  return ze = r.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), i;
      function o(m) {
        var v = m;
        return t && (n.setAttribute("href", v), v = n.href), n.setAttribute("href", v), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return i = o(window.location.href), function(v) {
        var f = r.isString(v) ? o(v) : v;
        return f.protocol === i.protocol && f.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), ze;
}
var He, Ur;
function jn() {
  if (Ur)
    return He;
  Ur = 1;
  var r = B;
  return He = r.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, i, o, m, v, f) {
          var S = [];
          S.push(n + "=" + encodeURIComponent(i)), r.isNumber(o) && S.push("expires=" + new Date(o).toGMTString()), r.isString(m) && S.push("path=" + m), r.isString(v) && S.push("domain=" + v), f === !0 && S.push("secure"), document.cookie = S.join("; ");
        },
        read: function(n) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), He;
}
var $e, Nr;
function Vr() {
  if (Nr)
    return $e;
  Nr = 1;
  var r = B, e = Fn(), t = Qr, n = Wn(), i = qn(), o = Dn(), m = rt();
  return $e = function(f) {
    return new Promise(function(g, P) {
      var s = f.data, l = f.headers;
      r.isFormData(s) && delete l["Content-Type"];
      var a = new XMLHttpRequest();
      if (f.auth) {
        var u = f.auth.username || "", d = f.auth.password || "";
        l.Authorization = "Basic " + btoa(u + ":" + d);
      }
      var U = n(f.baseURL, f.url);
      if (a.open(f.method.toUpperCase(), t(U, f.params, f.paramsSerializer), !0), a.timeout = f.timeout, a.onreadystatechange = function() {
        if (!(!a || a.readyState !== 4) && !(a.status === 0 && !(a.responseURL && a.responseURL.indexOf("file:") === 0))) {
          var A = "getAllResponseHeaders" in a ? i(a.getAllResponseHeaders()) : null, I = !f.responseType || f.responseType === "text" ? a.responseText : a.response, re = {
            data: I,
            status: a.status,
            statusText: a.statusText,
            headers: A,
            config: f,
            request: a
          };
          e(g, P, re), a = null;
        }
      }, a.onabort = function() {
        a && (P(m("Request aborted", f, "ECONNABORTED", a)), a = null);
      }, a.onerror = function() {
        P(m("Network Error", f, null, a)), a = null;
      }, a.ontimeout = function() {
        var A = "timeout of " + f.timeout + "ms exceeded";
        f.timeoutErrorMessage && (A = f.timeoutErrorMessage), P(m(
          A,
          f,
          "ECONNABORTED",
          a
        )), a = null;
      }, r.isStandardBrowserEnv()) {
        var G = jn(), h = (f.withCredentials || o(U)) && f.xsrfCookieName ? G.read(f.xsrfCookieName) : void 0;
        h && (l[f.xsrfHeaderName] = h);
      }
      if ("setRequestHeader" in a && r.forEach(l, function(A, I) {
        typeof s > "u" && I.toLowerCase() === "content-type" ? delete l[I] : a.setRequestHeader(I, A);
      }), r.isUndefined(f.withCredentials) || (a.withCredentials = !!f.withCredentials), f.responseType)
        try {
          a.responseType = f.responseType;
        } catch (p) {
          if (f.responseType !== "json")
            throw p;
        }
      typeof f.onDownloadProgress == "function" && a.addEventListener("progress", f.onDownloadProgress), typeof f.onUploadProgress == "function" && a.upload && a.upload.addEventListener("progress", f.onUploadProgress), f.cancelToken && f.cancelToken.promise.then(function(A) {
        a && (a.abort(), P(A), a = null);
      }), s === void 0 && (s = null), a.send(s);
    });
  }, $e;
}
var N = B, Br = Vn, zn = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Fr(r, e) {
  !N.isUndefined(r) && N.isUndefined(r["Content-Type"]) && (r["Content-Type"] = e);
}
function Hn() {
  var r;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (r = Vr()), r;
}
var Ae = {
  adapter: Hn(),
  transformRequest: [function(e, t) {
    return Br(t, "Accept"), Br(t, "Content-Type"), N.isFormData(e) || N.isArrayBuffer(e) || N.isBuffer(e) || N.isStream(e) || N.isFile(e) || N.isBlob(e) ? e : N.isArrayBufferView(e) ? e.buffer : N.isURLSearchParams(e) ? (Fr(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : N.isObject(e) ? (Fr(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
  }],
  transformResponse: [function(e) {
    if (typeof e == "string")
      try {
        e = JSON.parse(e);
      } catch {
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
Ae.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
N.forEach(["delete", "get", "head"], function(e) {
  Ae.headers[e] = {};
});
N.forEach(["post", "put", "patch"], function(e) {
  Ae.headers[e] = N.merge(zn);
});
var tt = Ae, Lr = B, Ye = Un, $n = et(), Yn = tt;
function Ge(r) {
  r.cancelToken && r.cancelToken.throwIfRequested();
}
var Gn = function(e) {
  Ge(e), e.headers = e.headers || {}, e.data = Ye(
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = Lr.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), Lr.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete e.headers[i];
    }
  );
  var t = e.adapter || Yn.adapter;
  return t(e).then(function(i) {
    return Ge(e), i.data = Ye(
      i.data,
      i.headers,
      e.transformResponse
    ), i;
  }, function(i) {
    return $n(i) || (Ge(e), i && i.response && (i.response.data = Ye(
      i.response.data,
      i.response.headers,
      e.transformResponse
    ))), Promise.reject(i);
  });
}, H = B, nt = function(e, t) {
  t = t || {};
  var n = {}, i = ["url", "method", "params", "data"], o = ["headers", "auth", "proxy"], m = [
    "baseURL",
    "url",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "maxContentLength",
    "validateStatus",
    "maxRedirects",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath"
  ];
  H.forEach(i, function(g) {
    typeof t[g] < "u" && (n[g] = t[g]);
  }), H.forEach(o, function(g) {
    H.isObject(t[g]) ? n[g] = H.deepMerge(e[g], t[g]) : typeof t[g] < "u" ? n[g] = t[g] : H.isObject(e[g]) ? n[g] = H.deepMerge(e[g]) : typeof e[g] < "u" && (n[g] = e[g]);
  }), H.forEach(m, function(g) {
    typeof t[g] < "u" ? n[g] = t[g] : typeof e[g] < "u" && (n[g] = e[g]);
  });
  var v = i.concat(o).concat(m), f = Object.keys(t).filter(function(g) {
    return v.indexOf(g) === -1;
  });
  return H.forEach(f, function(g) {
    typeof t[g] < "u" ? n[g] = t[g] : typeof e[g] < "u" && (n[g] = e[g]);
  }), n;
}, Ee = B, Xn = Qr, _r = Rn, Kn = Gn, it = nt;
function ue(r) {
  this.defaults = r, this.interceptors = {
    request: new _r(),
    response: new _r()
  };
}
ue.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = it(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var t = [Kn, void 0], n = Promise.resolve(e);
  for (this.interceptors.request.forEach(function(o) {
    t.unshift(o.fulfilled, o.rejected);
  }), this.interceptors.response.forEach(function(o) {
    t.push(o.fulfilled, o.rejected);
  }); t.length; )
    n = n.then(t.shift(), t.shift());
  return n;
};
ue.prototype.getUri = function(e) {
  return e = it(this.defaults, e), Xn(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
Ee.forEach(["delete", "get", "head", "options"], function(e) {
  ue.prototype[e] = function(t, n) {
    return this.request(Ee.merge(n || {}, {
      method: e,
      url: t
    }));
  };
});
Ee.forEach(["post", "put", "patch"], function(e) {
  ue.prototype[e] = function(t, n, i) {
    return this.request(Ee.merge(i || {}, {
      method: e,
      url: t,
      data: n
    }));
  };
});
var Zn = ue, Xe, Wr;
function at() {
  if (Wr)
    return Xe;
  Wr = 1;
  function r(e) {
    this.message = e;
  }
  return r.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, r.prototype.__CANCEL__ = !0, Xe = r, Xe;
}
var Ke, qr;
function Jn() {
  if (qr)
    return Ke;
  qr = 1;
  var r = at();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(m) {
      n = m;
    });
    var i = this;
    t(function(m) {
      i.reason || (i.reason = new r(m), n(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var n, i = new e(function(m) {
      n = m;
    });
    return {
      token: i,
      cancel: n
    };
  }, Ke = e, Ke;
}
var Ze, Dr;
function Qn() {
  return Dr || (Dr = 1, Ze = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), Ze;
}
var jr = B, ei = Gr, ge = Zn, ri = nt, ti = tt;
function ot(r) {
  var e = new ge(r), t = ei(ge.prototype.request, e);
  return jr.extend(t, ge.prototype, e), jr.extend(t, e), t;
}
var j = ot(ti);
j.Axios = ge;
j.create = function(e) {
  return ot(ri(j.defaults, e));
};
j.Cancel = at();
j.CancelToken = Jn();
j.isCancel = et();
j.all = function(e) {
  return Promise.all(e);
};
j.spread = Qn();
or.exports = j;
or.exports.default = j;
var ni = or.exports, ii = ni;
const ai = /* @__PURE__ */ pn(ii), Ma = (r, e, t) => Math.max(Math.min(r, t), e), Ra = (r, e, t, n, i) => {
  const o = t / n;
  let m, v;
  return t > n ? (i === "fill" ? m = Math.ceil(Math.max(e * o, r)) : m = Math.ceil(Math.min(e * o, r)), v = Math.ceil(m / o)) : (i === "fill" ? v = Math.ceil(Math.max(r / o, e)) : v = Math.ceil(Math.min(r / o, e)), m = Math.ceil(v * o)), { idealWidth: m, idealHeight: v };
}, Ia = (r, e) => {
  r && ai({
    url: r,
    method: "GET",
    responseType: "blob"
  }).then((t) => {
    const n = window.URL.createObjectURL(new Blob([t.data])), i = document.createElement("a");
    i.href = n, i.setAttribute("download", e ?? ""), document.body.appendChild(i), i.click(), document.body.removeChild(i);
  });
};
var c = {}, rr = { exports: {} };
(function(r, e) {
  (function(t, n) {
    var i = "1.0.40", o = "", m = "?", v = "function", f = "undefined", S = "object", g = "string", P = "major", s = "model", l = "name", a = "type", u = "vendor", d = "version", U = "architecture", G = "console", h = "mobile", p = "tablet", A = "smarttv", I = "wearable", re = "embedded", ke = 500, ce = "Amazon", te = "Apple", dr = "ASUS", cr = "BlackBerry", fe = "Browser", me = "Chrome", on = "Edge", pe = "Firefox", ne = "Google", fr = "Huawei", Me = "LG", Re = "Microsoft", mr = "Motorola", ie = "Opera", ae = "Samsung", pr = "Sharp", be = "Sony", Ie = "Xiaomi", Ue = "Zebra", br = "Facebook", vr = "Chromium OS", wr = "Mac OS", hr = " Browser", sn = function(E, T) {
      var y = {};
      for (var x in E)
        T[x] && T[x].length % 2 === 0 ? y[x] = T[x].concat(E[x]) : y[x] = E[x];
      return y;
    }, ve = function(E) {
      for (var T = {}, y = 0; y < E.length; y++)
        T[E[y].toUpperCase()] = E[y];
      return T;
    }, gr = function(E, T) {
      return typeof E === g ? X(T).indexOf(X(E)) !== -1 : !1;
    }, X = function(E) {
      return E.toLowerCase();
    }, un = function(E) {
      return typeof E === g ? E.replace(/[^\d\.]/g, o).split(".")[0] : n;
    }, Ne = function(E, T) {
      if (typeof E === g)
        return E = E.replace(/^\s\s*/, o), typeof T === f ? E : E.substring(0, ke);
    }, oe = function(E, T) {
      for (var y = 0, x, z, W, O, w, q; y < T.length && !w; ) {
        var Ve = T[y], Tr = T[y + 1];
        for (x = z = 0; x < Ve.length && !w && Ve[x]; )
          if (w = Ve[x++].exec(E), w)
            for (W = 0; W < Tr.length; W++)
              q = w[++z], O = Tr[W], typeof O === S && O.length > 0 ? O.length === 2 ? typeof O[1] == v ? this[O[0]] = O[1].call(this, q) : this[O[0]] = O[1] : O.length === 3 ? typeof O[1] === v && !(O[1].exec && O[1].test) ? this[O[0]] = q ? O[1].call(this, q, O[2]) : n : this[O[0]] = q ? q.replace(O[1], O[2]) : n : O.length === 4 && (this[O[0]] = q ? O[3].call(this, q.replace(O[1], O[2])) : n) : this[O] = q || n;
        y += 2;
      }
    }, we = function(E, T) {
      for (var y in T)
        if (typeof T[y] === S && T[y].length > 0) {
          for (var x = 0; x < T[y].length; x++)
            if (gr(T[y][x], E))
              return y === m ? n : y;
        } else if (gr(T[y], E))
          return y === m ? n : y;
      return T.hasOwnProperty("*") ? T["*"] : E;
    }, ln = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, yr = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Er = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [d, [l, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [d, [l, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [l, d], [/opios[\/ ]+([\w\.]+)/i], [d, [l, ie + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [d, [l, ie + " GX"]], [/\bopr\/([\w\.]+)/i], [d, [l, ie]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [d, [l, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [d, [l, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [l, d], [/quark(?:pc)?\/([-\w\.]+)/i], [d, [l, "Quark"]], [/\bddg\/([\w\.]+)/i], [d, [l, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [d, [l, "UC" + fe]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [d, [l, "WeChat"]], [/konqueror\/([\w\.]+)/i], [d, [l, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [d, [l, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [d, [l, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [d, [l, "Smart Lenovo " + fe]], [/(avast|avg)\/([\w\.]+)/i], [[l, /(.+)/, "$1 Secure " + fe], d], [/\bfocus\/([\w\.]+)/i], [d, [l, pe + " Focus"]], [/\bopt\/([\w\.]+)/i], [d, [l, ie + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [d, [l, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [d, [l, "Dolphin"]], [/coast\/([\w\.]+)/i], [d, [l, ie + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [d, [l, "MIUI" + hr]], [/fxios\/([\w\.-]+)/i], [d, [l, pe]], [/\bqihoobrowser\/?([\w\.]*)/i], [d, [l, "360"]], [/\b(qq)\/([\w\.]+)/i], [[l, /(.+)/, "$1Browser"], d], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[l, /(.+)/, "$1" + hr], d], [/samsungbrowser\/([\w\.]+)/i], [d, [l, ae + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [d, [l, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[l, "Sogou Mobile"], d], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [l, d], [/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i], [l], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [d, l], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[l, br], d], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [l, d], [/\bgsa\/([\w\.]+) .*safari\//i], [d, [l, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [d, [l, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [d, [l, me + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[l, me + " WebView"], d], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [d, [l, "Android " + fe]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [l, d], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [d, [l, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [d, l], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [l, [d, we, ln]], [/(webkit|khtml)\/([\w\.]+)/i], [l, d], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[l, "Netscape"], d], [/(wolvic|librewolf)\/([\w\.]+)/i], [l, d], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [d, [l, pe + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [l, [d, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [l, [d, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[U, "amd64"]], [/(ia32(?=;))/i], [[U, X]], [/((?:i[346]|x)86)[;\)]/i], [[U, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[U, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[U, "armhf"]], [/windows (ce|mobile); ppc;/i], [[U, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[U, /ower/, o, X]], [/(sun4\w)[;\)]/i], [[U, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[U, X]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [s, [u, ae], [a, p]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [s, [u, ae], [a, h]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [s, [u, te], [a, h]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [s, [u, te], [a, p]], [/(macintosh);/i], [s, [u, te]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [s, [u, pr], [a, h]], [/(?:honor)([-\w ]+)[;\)]/i], [s, [u, "Honor"], [a, h]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [s, [u, fr], [a, p]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [s, [u, fr], [a, h]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i], [[s, /_/g, " "], [u, Ie], [a, h]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[s, /_/g, " "], [u, Ie], [a, p]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [s, [u, "OPPO"], [a, h]], [/\b(opd2\d{3}a?) bui/i], [s, [u, "OPPO"], [a, p]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [s, [u, "Vivo"], [a, h]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [s, [u, "Realme"], [a, h]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [s, [u, mr], [a, h]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [s, [u, mr], [a, p]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [s, [u, Me], [a, p]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [s, [u, Me], [a, h]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [s, [u, "Lenovo"], [a, p]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[s, /_/g, " "], [u, "Nokia"], [a, h]], [/(pixel c)\b/i], [s, [u, ne], [a, p]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [s, [u, ne], [a, h]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [s, [u, be], [a, h]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[s, "Xperia Tablet"], [u, be], [a, p]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [s, [u, "OnePlus"], [a, h]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [s, [u, ce], [a, p]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[s, /(.+)/g, "Fire Phone $1"], [u, ce], [a, h]], [/(playbook);[-\w\),; ]+(rim)/i], [s, u, [a, p]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [s, [u, cr], [a, h]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [s, [u, dr], [a, p]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [s, [u, dr], [a, h]], [/(nexus 9)/i], [s, [u, "HTC"], [a, p]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [u, [s, /_/g, " "], [a, h]], [/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i], [s, [u, "TCL"], [a, p]], [/(itel) ((\w+))/i], [[u, X], s, [a, we, { tablet: ["p10001l", "w7001"], "*": "mobile" }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [s, [u, "Acer"], [a, p]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [s, [u, "Meizu"], [a, h]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [s, [u, "Ulefone"], [a, h]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [s, [u, "Energizer"], [a, h]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [s, [u, "Cat"], [a, h]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [s, [u, "Smartfren"], [a, h]], [/droid.+; (a(?:015|06[35]|142p?))/i], [s, [u, "Nothing"], [a, h]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [u, s, [a, h]], [/(imo) (tab \w+)/i, /(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [u, s, [a, p]], [/(surface duo)/i], [s, [u, Re], [a, p]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [s, [u, "Fairphone"], [a, h]], [/(u304aa)/i], [s, [u, "AT&T"], [a, h]], [/\bsie-(\w*)/i], [s, [u, "Siemens"], [a, h]], [/\b(rct\w+) b/i], [s, [u, "RCA"], [a, p]], [/\b(venue[\d ]{2,7}) b/i], [s, [u, "Dell"], [a, p]], [/\b(q(?:mv|ta)\w+) b/i], [s, [u, "Verizon"], [a, p]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [s, [u, "Barnes & Noble"], [a, p]], [/\b(tm\d{3}\w+) b/i], [s, [u, "NuVision"], [a, p]], [/\b(k88) b/i], [s, [u, "ZTE"], [a, p]], [/\b(nx\d{3}j) b/i], [s, [u, "ZTE"], [a, h]], [/\b(gen\d{3}) b.+49h/i], [s, [u, "Swiss"], [a, h]], [/\b(zur\d{3}) b/i], [s, [u, "Swiss"], [a, p]], [/\b((zeki)?tb.*\b) b/i], [s, [u, "Zeki"], [a, p]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[u, "Dragon Touch"], s, [a, p]], [/\b(ns-?\w{0,9}) b/i], [s, [u, "Insignia"], [a, p]], [/\b((nxa|next)-?\w{0,9}) b/i], [s, [u, "NextBook"], [a, p]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[u, "Voice"], s, [a, h]], [/\b(lvtel\-)?(v1[12]) b/i], [[u, "LvTel"], s, [a, h]], [/\b(ph-1) /i], [s, [u, "Essential"], [a, h]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [s, [u, "Envizen"], [a, p]], [/\b(trio[-\w\. ]+) b/i], [s, [u, "MachSpeed"], [a, p]], [/\btu_(1491) b/i], [s, [u, "Rotor"], [a, p]], [/(shield[\w ]+) b/i], [s, [u, "Nvidia"], [a, p]], [/(sprint) (\w+)/i], [u, s, [a, h]], [/(kin\.[onetw]{3})/i], [[s, /\./g, " "], [u, Re], [a, h]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [s, [u, Ue], [a, p]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [s, [u, Ue], [a, h]], [/smart-tv.+(samsung)/i], [u, [a, A]], [/hbbtv.+maple;(\d+)/i], [[s, /^/, "SmartTV"], [u, ae], [a, A]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[u, Me], [a, A]], [/(apple) ?tv/i], [u, [s, te + " TV"], [a, A]], [/crkey/i], [[s, me + "cast"], [u, ne], [a, A]], [/droid.+aft(\w+)( bui|\))/i], [s, [u, ce], [a, A]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [s, [u, pr], [a, A]], [/(bravia[\w ]+)( bui|\))/i], [s, [u, be], [a, A]], [/(mitv-\w{5}) bui/i], [s, [u, Ie], [a, A]], [/Hbbtv.*(technisat) (.*);/i], [u, s, [a, A]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[u, Ne], [s, Ne], [a, A]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[a, A]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [u, s, [a, G]], [/droid.+; (shield) bui/i], [s, [u, "Nvidia"], [a, G]], [/(playstation [345portablevi]+)/i], [s, [u, be], [a, G]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [s, [u, Re], [a, G]], [/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i], [s, [u, ae], [a, I]], [/((pebble))app/i], [u, s, [a, I]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [s, [u, te], [a, I]], [/droid.+; (glass) \d/i], [s, [u, ne], [a, I]], [/droid.+; (wt63?0{2,3})\)/i], [s, [u, Ue], [a, I]], [/droid.+; (glass) \d/i], [s, [u, ne], [a, I]], [/(pico) (4|neo3(?: link|pro)?)/i], [u, s, [a, I]], [/; (quest( \d| pro)?)/i], [s, [u, br], [a, I]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [u, [a, re]], [/(aeobc)\b/i], [s, [u, ce], [a, re]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [s, [a, h]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [s, [a, p]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[a, p]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[a, h]], [/(android[-\w\. ]{0,9});.+buil/i], [s, [u, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [d, [l, on + "HTML"]], [/(arkweb)\/([\w\.]+)/i], [l, d], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [d, [l, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [l, d], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [d, l]], os: [[/microsoft (windows) (vista|xp)/i], [l, d], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [l, [d, we, yr]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[d, we, yr], [l, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[d, /_/g, "."], [l, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[l, wr], [d, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [d, l], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [l, d], [/\(bb(10);/i], [d, [l, cr]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [d, [l, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [d, [l, pe + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [d, [l, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [d, [l, "watchOS"]], [/crkey\/([\d\.]+)/i], [d, [l, me + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[l, vr], d], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [l, d], [/(sunos) ?([\w\.\d]*)/i], [[l, "Solaris"], d], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [l, d]] }, _ = function(E, T) {
      if (typeof E === S && (T = E, E = n), !(this instanceof _))
        return new _(E, T).getResult();
      var y = typeof t !== f && t.navigator ? t.navigator : n, x = E || (y && y.userAgent ? y.userAgent : o), z = y && y.userAgentData ? y.userAgentData : n, W = T ? sn(Er, T) : Er, O = y && y.userAgent == x;
      return this.getBrowser = function() {
        var w = {};
        return w[l] = n, w[d] = n, oe.call(w, x, W.browser), w[P] = un(w[d]), O && y && y.brave && typeof y.brave.isBrave == v && (w[l] = "Brave"), w;
      }, this.getCPU = function() {
        var w = {};
        return w[U] = n, oe.call(w, x, W.cpu), w;
      }, this.getDevice = function() {
        var w = {};
        return w[u] = n, w[s] = n, w[a] = n, oe.call(w, x, W.device), O && !w[a] && z && z.mobile && (w[a] = h), O && w[s] == "Macintosh" && y && typeof y.standalone !== f && y.maxTouchPoints && y.maxTouchPoints > 2 && (w[s] = "iPad", w[a] = p), w;
      }, this.getEngine = function() {
        var w = {};
        return w[l] = n, w[d] = n, oe.call(w, x, W.engine), w;
      }, this.getOS = function() {
        var w = {};
        return w[l] = n, w[d] = n, oe.call(w, x, W.os), O && !w[l] && z && z.platform && z.platform != "Unknown" && (w[l] = z.platform.replace(/chrome os/i, vr).replace(/macos/i, wr)), w;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return x;
      }, this.setUA = function(w) {
        return x = typeof w === g && w.length > ke ? Ne(w, ke) : w, this;
      }, this.setUA(x), this;
    };
    _.VERSION = i, _.BROWSER = ve([l, d, P]), _.CPU = ve([U]), _.DEVICE = ve([s, u, a, G, h, A, p, I, re]), _.ENGINE = _.OS = ve([l, d]), r.exports && (e = r.exports = _), e.UAParser = _;
    var K = typeof t !== f && (t.jQuery || t.Zepto);
    if (K && !K.ua) {
      var he = new _();
      K.ua = he.getResult(), K.ua.get = function() {
        return he.getUA();
      }, K.ua.set = function(E) {
        he.setUA(E);
        var T = he.getResult();
        for (var y in T)
          K.ua[y] = T[y];
      };
    }
  })(typeof window == "object" ? window : mn);
})(rr, rr.exports);
var oi = rr.exports;
Object.defineProperty(c, "__esModule", { value: !0 });
function si(r) {
  return r && typeof r == "object" && "default" in r ? r.default : r;
}
var M = dn, C = si(M), st = oi, $ = new st(), R = $.getBrowser(), ui = $.getCPU(), F = $.getDevice(), sr = $.getEngine(), Y = $.getOS(), le = $.getUA(), ut = function(e) {
  return $.setUA(e);
}, de = function(e) {
  if (!e) {
    console.error("No userAgent string was provided");
    return;
  }
  var t = new st(e);
  return {
    UA: t,
    browser: t.getBrowser(),
    cpu: t.getCPU(),
    device: t.getDevice(),
    engine: t.getEngine(),
    os: t.getOS(),
    ua: t.getUA(),
    setUserAgent: function(i) {
      return t.setUA(i);
    }
  };
}, lt = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: $,
  browser: R,
  cpu: ui,
  device: F,
  engine: sr,
  os: Y,
  ua: le,
  setUa: ut,
  parseUserAgent: de
});
function zr(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function li(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zr(Object(t), !0).forEach(function(n) {
      fi(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : zr(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function se(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? se = function(e) {
    return typeof e;
  } : se = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, se(r);
}
function di(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Hr(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function ci(r, e, t) {
  return e && Hr(r.prototype, e), t && Hr(r, t), r;
}
function fi(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function tr() {
  return tr = Object.assign || function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, tr.apply(this, arguments);
}
function mi(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && ir(r, e);
}
function nr(r) {
  return nr = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, nr(r);
}
function ir(r, e) {
  return ir = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, ir(r, e);
}
function pi(r, e) {
  if (r == null)
    return {};
  var t = {}, n = Object.keys(r), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (t[i] = r[i]);
  return t;
}
function L(r, e) {
  if (r == null)
    return {};
  var t = pi(r, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(r);
    for (i = 0; i < o.length; i++)
      n = o[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(r, n) && (t[n] = r[n]);
  }
  return t;
}
function ye(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function bi(r, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ye(r);
}
function vi(r, e) {
  return wi(r) || hi(r, e) || gi(r, e) || yi();
}
function wi(r) {
  if (Array.isArray(r))
    return r;
}
function hi(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var n = [], i = !0, o = !1, m, v;
    try {
      for (t = t.call(r); !(i = (m = t.next()).done) && (n.push(m.value), !(e && n.length === e)); i = !0)
        ;
    } catch (f) {
      o = !0, v = f;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (o)
          throw v;
      }
    }
    return n;
  }
}
function gi(r, e) {
  if (r) {
    if (typeof r == "string")
      return $r(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return $r(r, e);
  }
}
function $r(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function yi() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var k = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, V = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, ee = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, Ei = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, Ti = function(e) {
  switch (e) {
    case k.Mobile:
      return {
        isMobile: !0
      };
    case k.Tablet:
      return {
        isTablet: !0
      };
    case k.SmartTv:
      return {
        isSmartTV: !0
      };
    case k.Console:
      return {
        isConsole: !0
      };
    case k.Wearable:
      return {
        isWearable: !0
      };
    case k.Browser:
      return {
        isBrowser: !0
      };
    case k.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return Ei;
  }
}, Oi = function(e) {
  return ut(e);
}, b = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return e || t;
}, ur = function() {
  return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, lr = function(e) {
  var t = ur();
  return t && t.platform && (t.platform.indexOf(e) !== -1 || t.platform === "MacIntel" && t.maxTouchPoints > 1 && !window.MSStream);
}, Si = function(e, t, n, i, o) {
  return {
    isBrowser: e,
    browserMajorVersion: b(t.major),
    browserFullVersion: b(t.version),
    browserName: b(t.name),
    engineName: b(n.name),
    engineVersion: b(n.version),
    osName: b(i.name),
    osVersion: b(i.version),
    userAgent: b(o)
  };
}, Yr = function(e, t, n, i) {
  return li({}, e, {
    vendor: b(t.vendor),
    model: b(t.model),
    os: b(n.name),
    osVersion: b(n.version),
    ua: b(i)
  });
}, xi = function(e, t, n, i) {
  return {
    isSmartTV: e,
    engineName: b(t.name),
    engineVersion: b(t.version),
    osName: b(n.name),
    osVersion: b(n.version),
    userAgent: b(i)
  };
}, Ci = function(e, t, n, i) {
  return {
    isConsole: e,
    engineName: b(t.name),
    engineVersion: b(t.version),
    osName: b(n.name),
    osVersion: b(n.version),
    userAgent: b(i)
  };
}, Ai = function(e, t, n, i) {
  return {
    isWearable: e,
    engineName: b(t.name),
    engineVersion: b(t.version),
    osName: b(n.name),
    osVersion: b(n.version),
    userAgent: b(i)
  };
}, Pi = function(e, t, n, i, o) {
  return {
    isEmbedded: e,
    vendor: b(t.vendor),
    model: b(t.model),
    engineName: b(n.name),
    engineVersion: b(n.version),
    osName: b(i.name),
    osVersion: b(i.version),
    userAgent: b(o)
  };
};
function ki(r) {
  var e = r ? de(r) : lt, t = e.device, n = e.browser, i = e.engine, o = e.os, m = e.ua, v = Ti(t.type), f = v.isBrowser, S = v.isMobile, g = v.isTablet, P = v.isSmartTV, s = v.isConsole, l = v.isWearable, a = v.isEmbedded;
  if (f)
    return Si(f, n, i, o, m);
  if (P)
    return xi(P, i, o, m);
  if (s)
    return Ci(s, i, o, m);
  if (S || g)
    return Yr(v, t, o, m);
  if (l)
    return Ai(l, i, o, m);
  if (a)
    return Pi(a, t, i, o, m);
}
var dt = function(e) {
  var t = e.type;
  return t === k.Mobile;
}, ct = function(e) {
  var t = e.type;
  return t === k.Tablet;
}, ft = function(e) {
  var t = e.type;
  return t === k.Mobile || t === k.Tablet;
}, mt = function(e) {
  var t = e.type;
  return t === k.SmartTv;
}, Te = function(e) {
  var t = e.type;
  return t === k.Browser;
}, pt = function(e) {
  var t = e.type;
  return t === k.Wearable;
}, bt = function(e) {
  var t = e.type;
  return t === k.Console;
}, vt = function(e) {
  var t = e.type;
  return t === k.Embedded;
}, wt = function(e) {
  var t = e.vendor;
  return b(t);
}, ht = function(e) {
  var t = e.model;
  return b(t);
}, gt = function(e) {
  var t = e.type;
  return b(t, "browser");
}, yt = function(e) {
  var t = e.name;
  return t === ee.Android;
}, Et = function(e) {
  var t = e.name;
  return t === ee.Windows;
}, Tt = function(e) {
  var t = e.name;
  return t === ee.MAC_OS;
}, Ot = function(e) {
  var t = e.name;
  return t === ee.WindowsPhone;
}, St = function(e) {
  var t = e.name;
  return t === ee.IOS;
}, xt = function(e) {
  var t = e.version;
  return b(t);
}, Ct = function(e) {
  var t = e.name;
  return b(t);
}, At = function(e) {
  var t = e.name;
  return t === V.Chrome;
}, Pt = function(e) {
  var t = e.name;
  return t === V.Firefox;
}, kt = function(e) {
  var t = e.name;
  return t === V.Chromium;
}, Oe = function(e) {
  var t = e.name;
  return t === V.Edge;
}, Mt = function(e) {
  var t = e.name;
  return t === V.Yandex;
}, Rt = function(e) {
  var t = e.name;
  return t === V.Safari || t === V.MobileSafari;
}, It = function(e) {
  var t = e.name;
  return t === V.MobileSafari;
}, Ut = function(e) {
  var t = e.name;
  return t === V.Opera;
}, Nt = function(e) {
  var t = e.name;
  return t === V.InternetExplorer || t === V.Ie;
}, Vt = function(e) {
  var t = e.name;
  return t === V.MIUI;
}, Bt = function(e) {
  var t = e.name;
  return t === V.SamsungBrowser;
}, Ft = function(e) {
  var t = e.version;
  return b(t);
}, Lt = function(e) {
  var t = e.major;
  return b(t);
}, _t = function(e) {
  var t = e.name;
  return b(t);
}, Wt = function(e) {
  var t = e.name;
  return b(t);
}, qt = function(e) {
  var t = e.version;
  return b(t);
}, Dt = function() {
  var e = ur(), t = e && e.userAgent && e.userAgent.toLowerCase();
  return typeof t == "string" ? /electron/.test(t) : !1;
}, J = function(e) {
  return typeof e == "string" && e.indexOf("Edg/") !== -1;
}, jt = function() {
  var e = ur();
  return e && (/iPad|iPhone|iPod/.test(e.platform) || e.platform === "MacIntel" && e.maxTouchPoints > 1) && !window.MSStream;
}, D = function() {
  return lr("iPad");
}, zt = function() {
  return lr("iPhone");
}, Ht = function() {
  return lr("iPod");
}, $t = function(e) {
  return b(e);
};
function Yt(r) {
  var e = r || lt, t = e.device, n = e.browser, i = e.os, o = e.engine, m = e.ua;
  return {
    isSmartTV: mt(t),
    isConsole: bt(t),
    isWearable: pt(t),
    isEmbedded: vt(t),
    isMobileSafari: It(n) || D(),
    isChromium: kt(n),
    isMobile: ft(t) || D(),
    isMobileOnly: dt(t),
    isTablet: ct(t) || D(),
    isBrowser: Te(t),
    isDesktop: Te(t),
    isAndroid: yt(i),
    isWinPhone: Ot(i),
    isIOS: St(i) || D(),
    isChrome: At(n),
    isFirefox: Pt(n),
    isSafari: Rt(n),
    isOpera: Ut(n),
    isIE: Nt(n),
    osVersion: xt(i),
    osName: Ct(i),
    fullBrowserVersion: Ft(n),
    browserVersion: Lt(n),
    browserName: _t(n),
    mobileVendor: wt(t),
    mobileModel: ht(t),
    engineName: Wt(o),
    engineVersion: qt(o),
    getUA: $t(m),
    isEdge: Oe(n) || J(m),
    isYandex: Mt(n),
    deviceType: gt(t),
    isIOS13: jt(),
    isIPad13: D(),
    isIPhone13: zt(),
    isIPod13: Ht(),
    isElectron: Dt(),
    isEdgeChromium: J(m),
    isLegacyEdge: Oe(n) && !J(m),
    isWindows: Et(i),
    isMacOs: Tt(i),
    isMIUI: Vt(n),
    isSamsungBrowser: Bt(n)
  };
}
var Gt = mt(F), Xt = bt(F), Kt = pt(F), Mi = vt(F), Ri = It(R) || D(), Ii = kt(R), Pe = ft(F) || D(), Zt = dt(F), Jt = ct(F) || D(), Qt = Te(F), Ui = Te(F), en = yt(Y), rn = Ot(Y), tn = St(Y) || D(), Ni = At(R), Vi = Pt(R), Bi = Rt(R), Fi = Ut(R), nn = Nt(R), Li = xt(Y), _i = Ct(Y), Wi = Ft(R), qi = Lt(R), Di = _t(R), ji = wt(F), zi = ht(F), Hi = Wt(sr), $i = qt(sr), Yi = $t(le), Gi = Oe(R) || J(le), Xi = Mt(R), Ki = gt(F), Zi = jt(), Ji = D(), Qi = zt(), ea = Ht(), ra = Dt(), ta = J(le), na = Oe(R) && !J(le), ia = Et(Y), aa = Tt(Y), oa = Vt(R), sa = Bt(R), ua = function(e) {
  if (!e || typeof e != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var t = de(e), n = t.device, i = t.browser, o = t.os, m = t.engine, v = t.ua;
  return Yt({
    device: n,
    browser: i,
    os: o,
    engine: m,
    ua: v
  });
}, la = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return en ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, da = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Qt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ca = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return nn ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, fa = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return tn ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ma = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Pe ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, pa = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Jt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ba = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return rn ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, va = function(e) {
  var t = e.renderWithFragment, n = e.children;
  e.viewClassName, e.style;
  var i = L(e, ["renderWithFragment", "children", "viewClassName", "style"]);
  return Zt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, wa = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Gt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ha = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Xt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ga = function(e) {
  var t = e.renderWithFragment, n = e.children, i = L(e, ["renderWithFragment", "children"]);
  return Kt ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", i, n) : null;
}, ya = function(e) {
  var t = e.renderWithFragment, n = e.children;
  e.viewClassName, e.style;
  var i = e.condition, o = L(e, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return i ? t ? C.createElement(M.Fragment, null, n) : C.createElement("div", o, n) : null;
};
function Ea(r) {
  return /* @__PURE__ */ function(e) {
    mi(t, e);
    function t(n) {
      var i;
      return di(this, t), i = bi(this, nr(t).call(this, n)), i.isEventListenerAdded = !1, i.handleOrientationChange = i.handleOrientationChange.bind(ye(i)), i.onOrientationChange = i.onOrientationChange.bind(ye(i)), i.onPageLoad = i.onPageLoad.bind(ye(i)), i.state = {
        isLandscape: !1,
        isPortrait: !1
      }, i;
    }
    return ci(t, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var i = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: i === 0,
          isLandscape: i === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window > "u" ? "undefined" : se(window)) !== void 0 && Pe && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return C.createElement(r, tr({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), t;
  }(C.Component);
}
function Ta() {
  var r = M.useState(function() {
    var o = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: o === 0,
      isLandscape: o === 90,
      orientation: o === 0 ? "portrait" : "landscape"
    };
  }), e = vi(r, 2), t = e[0], n = e[1], i = M.useCallback(function() {
    var o = window.innerWidth > window.innerHeight ? 90 : 0, m = {
      isPortrait: o === 0,
      isLandscape: o === 90,
      orientation: o === 0 ? "portrait" : "landscape"
    };
    t.orientation !== m.orientation && n(m);
  }, [t.orientation]);
  return M.useEffect(function() {
    return (typeof window > "u" ? "undefined" : se(window)) !== void 0 && Pe && (i(), window.addEventListener("load", i, !1), window.addEventListener("resize", i, !1)), function() {
      window.removeEventListener("resize", i, !1), window.removeEventListener("load", i, !1);
    };
  }, [i]), t;
}
function an(r) {
  var e = r || window.navigator.userAgent;
  return de(e);
}
function Oa(r) {
  var e = r || window.navigator.userAgent, t = an(e), n = Yt(t);
  return [n, t];
}
c.AndroidView = la;
c.BrowserTypes = V;
c.BrowserView = da;
c.ConsoleView = ha;
c.CustomView = ya;
c.IEView = ca;
c.IOSView = fa;
c.MobileOnlyView = va;
c.MobileView = ma;
c.OsTypes = ee;
c.SmartTVView = wa;
c.TabletView = pa;
c.WearableView = ga;
c.WinPhoneView = ba;
c.browserName = Di;
c.browserVersion = qi;
c.deviceDetect = ki;
c.deviceType = Ki;
c.engineName = Hi;
c.engineVersion = $i;
c.fullBrowserVersion = Wi;
c.getSelectorsByUserAgent = ua;
c.getUA = Yi;
c.isAndroid = en;
c.isBrowser = Qt;
c.isChrome = Ni;
c.isChromium = Ii;
c.isConsole = Xt;
c.isDesktop = Ui;
var Sa = c.isEdge = Gi;
c.isEdgeChromium = ta;
c.isElectron = ra;
c.isEmbedded = Mi;
var Se = c.isFirefox = Vi, xa = c.isIE = nn;
c.isIOS = tn;
c.isIOS13 = Zi;
c.isIPad13 = Ji;
c.isIPhone13 = Qi;
c.isIPod13 = ea;
c.isLegacyEdge = na;
c.isMIUI = oa;
c.isMacOs = aa;
c.isMobile = Pe;
c.isMobileOnly = Zt;
c.isMobileSafari = Ri;
c.isOpera = Fi;
c.isSafari = Bi;
c.isSamsungBrowser = sa;
c.isSmartTV = Gt;
c.isTablet = Jt;
c.isWearable = Kt;
c.isWinPhone = rn;
c.isWindows = ia;
c.isYandex = Xi;
c.mobileModel = zi;
c.mobileVendor = ji;
c.osName = _i;
c.osVersion = Li;
c.parseUserAgent = de;
c.setUserAgent = Oi;
c.useDeviceData = an;
c.useDeviceSelectors = Oa;
c.useMobileOrientation = Ta;
c.withOrientationChange = Ea;
const Ua = (r) => {
  const e = {
    printable: null,
    fallbackPrintable: null,
    type: "pdf",
    onLoadingEnd: null,
    onPrintDialogClose: () => {
    },
    onError: (o) => {
      throw o;
    },
    frameId: "print-pdf-file",
    printableElement: null
  };
  e.printable = r.printable, e.fallbackPrintable = typeof r.fallbackPrintable < "u" ? r.fallbackPrintable : e.printable;
  let t;
  for (t in e)
    t === "printable" || t === "fallbackPrintable" || (e[t] = typeof r[t] < "u" ? r[t] : e[t]);
  const n = document.createElement("iframe"), i = Se ? "width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0" : "visibility: hidden; height: 0; width: 0; position: absolute; border: 0";
  n.setAttribute("style", i), n.setAttribute("id", e.frameId), Ca(e, n);
};
function ar(r) {
  r.onLoadingEnd && r.onLoadingEnd();
  const e = () => {
    window.removeEventListener("focus", e), r.onPrintDialogClose();
    const t = document.getElementById(r.frameId);
    t && t.remove();
  };
  window.addEventListener("focus", e);
}
const Ca = (r, e) => {
  r.printable = /^(blob|http|\/\/)/i.test(r.printable) ? r.printable : window.location.origin + (r.printable.charAt(0) !== "/" ? "/" + r.printable : r.printable);
  const t = new window.XMLHttpRequest();
  t.responseType = "arraybuffer", t.addEventListener("error", () => {
    ar(r), r.onError(t.statusText, t);
  }), t.addEventListener("load", () => {
    if ([200, 201].indexOf(t.status) === -1) {
      ar(r), r.onError(t.statusText, t);
      return;
    }
    Aa(r, e, t.response);
  }), t.open("GET", r.printable, !0), t.send();
};
function Aa(r, e, t) {
  let n = new window.Blob([t], { type: "application/pdf" });
  n = window.URL.createObjectURL(n), e.setAttribute("src", n), Pa(r, e);
}
function Je(r, e) {
  var t, n, i;
  try {
    if (Se || r.focus(), Sa || xa)
      try {
        (t = r.contentWindow) == null || t.document.execCommand("print", !1);
      } catch {
        (n = r.contentWindow) == null || n.print();
      }
    else
      (i = r.contentWindow) == null || i.print();
  } catch (o) {
    e.onError(o);
  } finally {
    Se && (r.style.visibility = "hidden", r.style.left = "-1px"), ar(e);
  }
}
function Pa(r, e) {
  document.getElementsByTagName("body")[0].appendChild(e);
  const t = document.getElementById(r.frameId);
  t.onload = () => {
    if (r.type === "pdf") {
      if (Se) {
        const i = setTimeout(() => {
          Je(t, r), clearTimeout(i);
        }, 1e3);
      } else
        Je(t, r);
      return;
    }
    let n = t.contentWindow || t.contentDocument;
    n != null && n.document && (n = n.document), n.body.appendChild(r.printableElement), Je(t, r);
  };
}
const Na = (r) => {
  const e = cn();
  return fn(() => {
    e.current = r;
  }), e.current;
};
export {
  Ra as calculateElementSizeInContainer,
  Ma as clamp,
  Ia as downloadBinaryWithProvidedFileName,
  Ua as printPdf,
  Na as usePrevious
};
